export default "__VITE_ASSET__3a2ec307__"